// extracted by mini-css-extract-plugin
export var textInput = "_e6-0";